import './OfferBrands.scss';
import React from 'react';
import Slider from 'react-slick';
import brand1 from '../../assets/img/brand1.webp';
import brand2 from '../../assets/img/brand2.webp';
import brand3 from '../../assets/img/brand3.webp';
import brand4 from '../../assets/img/brand4.webp';
import brand5 from '../../assets/img/brand5.webp';
import brand6 from '../../assets/img/brand6.webp';
import brand7 from '../../assets/img/brand7.webp';
import brand8 from '../../assets/img/brand8.webp';
import brand9 from '../../assets/img/brand9.webp';
import brand0 from '../../assets/img/brand0.svg';


let brandData = [
  {
    img:brand0,
    link:"https://www.euvic.com/"
  },
  {
    img:brand1,
    link:"https://accelpoint.com/"
  },
  {
    img:brand2,
    link:"https://spoko.app/"
  },
  {
    img:brand3,
    link:"https://startupwroclaw.pl/"
  },
  {
    img:brand4,
    link:"https://g-capital.pl/"
  },
  {
    img:brand5,
    link:"https://migrantexpert.pl/"
  },
  {
    img:brand6,
    link:"https://www.finexp.pl"
  },
  {
    img:brand7,
    link:"https://www.slovers.pl/"
  },
  {
    img:brand8,
    link:"https://tvoe.pl/"
  },
  {
    img:brand9,
    link:""
  },
];
let brandItem = brandData.map(item =>(

        <div className="brang-img" key={item}>
            <a href={item.link} target='blank'><img src={item.img} alt="img" /></a>
        </div>

))

function OfferBrands() {
    const settings = {
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
      
        slidesToScroll: 1,
         responsive: [
            {
              breakpoint: 1334,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 880,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                initialSlide: 2,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 724,
              settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false
              }
            },
            {
              breakpoint: 550,
              settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false
              }
            },
            {
              breakpoint: 428,
              settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: false
              }
            },
            {
              breakpoint: 390,
              settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false
              }
            }
          ]
      };
  return (
    <div className="offer-brands-wrapper">
        <div className="offer-items-wrapper">
            <div className="offer-items">
                <Slider {...settings}>
                    {brandItem}
                </Slider>
            </div>
        </div>    
    </div>
  );
}

export default OfferBrands;